'use client'
import Table, { TableColumn } from '../../views/table/Table'
import { ActivityItem } from '../../../utils/http/Services/market'
import Loading, { LoadingFrame } from '../../views/common/Loading'
import styled from 'styled-components'
import { XImage } from '../../views/common/XImage'
import { Images } from '../../../utils/images'
import { BtcIcon } from '../../views/common/Bitcoin'
import { formatFloat, formatSat } from '../../../utils'
import AddressLink from '../../views/common/AddressLink'
import moment from 'moment'
import useWindowInfiniteScroll from '../../../hooks/useWindowInfiniteScroll'
import { Services } from '../../../utils/http/Services'
import { I, isNoMore } from '../../../utils/http/infinite'
import { CardSize, OrderStatus } from '../../../utils/type'
import InscriptionCard from '../../views/common/InscriptionCard'
import { commonStyles } from '../../../utils/commonStyles'

const iconMap = {
  list: Images.DETAIL.LIST_SVG,
  sale: Images.DETAIL.SALE_SVG,
  unlisted: Images.DETAIL.UNLISTED_SVG,
  transfer: Images.DETAIL.TRANSFER_SVG,
  inscribed: Images.DETAIL.INSCRIBE_SVG,
}

const tableColumns: TableColumn<ActivityItem>[] = [
  {
    name: '',
    align: 'left',
    render: (data) => (
      <>
        <Loading size={19} style={{ opacity: data.order_status === OrderStatus.Pending ? 1 : 0 }} />
        <InscriptionCard content={data} size={CardSize.Small} style={{ margin: '0 9px' }} />
        Inscription #{data.ordinal_number}
      </>
    ),
  },
  {
    name: '',
    align: 'left',
    render: (data) => (
      <>
        <Icon src={iconMap[data.activityType]} />
        <TypeName>{data.activityType}</TypeName>
      </>
    ),
  },
  {
    name: '',
    align: 'left',
    render: (data) =>
      ['list', 'sale'].includes(data.activityType) ? (
        <>
          <BtcIcon right={5} /> {formatFloat(formatSat(data.price))} BTC
        </>
      ) : (
        <></>
      ),
  },
  {
    name: '',
    align: 'left',
    render: (data) => (
      <ActivityText>
        <span>
          <AddressLink addr={data.fromAddress} shorten={10} />
        </span>
        {data.toAddress && (
          <>
            {' '}
            to{' '}
            <span>
              <AddressLink addr={data.toAddress} shorten={10} />
            </span>
          </>
        )}
      </ActivityText>
    ),
  },
  {
    name: '',
    align: 'right',
    render: (data) => <Time>{moment.unix(data.blockTimestamp).fromNow()}</Time>,
  },
]
export default function ActivityTable(props: { collectionId: number }) {
  const { data, loading, loadingMore } = useWindowInfiniteScroll(
    I(Services.marketService.getActivities, {
      collectionId: props.collectionId,
      limit: 20,
    }),
    {
      reloadDeps: [props.collectionId],
      isNoMore,
    }
  )
  const list = data?.list || []
  const isLoading = loading || loadingMore
  return (
    <>
      {/*@ts-ignore*/}
      <StyledTable columns={tableColumns} data={list} />
      {isLoading && <StyledLoadingFrame size={40} />}
    </>
  )
}

const StyledLoadingFrame = styled(LoadingFrame)`
  width: 100%;
  height: 335px;
  ${commonStyles.flexCenter}
`

const StyledTable = styled(Table)`
  .table-td {
    color: #efefef;
    font-size: 14px;
  }
`

const Logo = styled(XImage)`
  margin: 0 9px;
  width: 30px;
  height: 30px;
`

const Icon = styled(XImage)`
  width: 15px;
  height: 15px;
  margin-right: 6px;
`

const TypeName = styled.span`
  font-size: 14px;
  color: #9e9e9e;
  line-height: 22px;
  text-transform: capitalize;
`

const ActivityText = styled.p`
  font-size: 12px;
  color: #9e9e9e;
  margin-top: 8px;
  span {
    color: #f5d802;
  }
`

const Time = styled.span`
  color: #9e9e9e;
  font-size: 12px;
`
